import $ from 'jquery';
import { initModal, setTitle } from './modal';
import { initForm } from './form';

function initModalAuthByEmail(modalElement) {
	new ModalAuthByEmail(modalElement);
}

function ModalAuthByEmail(modalElement) {
	this.domElem = modalElement;

	initModal(this.domElem);
	initForm(this.domElem);

	if (!this.titleSaved)
		this.titleSaved = $(this.domElem)
			.find('.modal-title')
			.text();

	$(this.domElem)
		.on('hidden.bs.modal', this.onHidden.bind(this))
		.find('.modal-auth-by-email__restore')
			.on('click', this.toggleRestore.bind(this))
			.end()
		.find('.modal-auth-by-email__form_type_login')
			.on('submit', this.onSubmitLogin.bind(this))
			.end()
		.find('.modal-auth-by-email__form_type_restore')
			.on('submit', this.onSubmitRestore.bind(this));
}

ModalAuthByEmail.prototype.onHidden = function() {
	setTitle(this.domElem, this.titleSaved);

	$(this.domElem)
		.find('.form')
		.trigger('_reset.form')
			.filter('.modal-auth-by-email__form_type_login')
			.removeClass('form_hidden')
		.end()
			.filter('.modal-auth-by-email__form_type_restore')
			.addClass('form_hidden')
		.end()
	.end()
		.find('.modal-auth-by-email__restore')
		.removeClass('modal-auth__link_hidden');
}

ModalAuthByEmail.prototype.toggleRestore = function() {
	const currentModalTitle = $(this.domElem)
		.find('.modal-title')
		.text();

	const isEqualToSavedTitle = currentModalTitle === this.titleSaved;

	const newModalTitle = isEqualToSavedTitle ? $(this.domElem).data('modal-title-restore') : this.titleSaved;

	setTitle(this.domElem, newModalTitle);

	$(this.domElem)
		.find('.form')
			.toggleClass('form_hidden')
			.filter('.form_hidden')
				.trigger('_reset.form')
				.end()
			.end()
		.find('.modal-auth-by-email__restore')
			.toggleClass('modal-auth__link_hidden');
}

ModalAuthByEmail.prototype.onSubmitLogin = function({ currentTarget }) {
	const data = $(currentTarget).serialize();
	const url = currentTarget.dataset.api;
	const method = currentTarget.method;
	const options = { url, method, data };

	if (this.xhr)
		this.xhr.abort();

	this.xhr = $.ajax(options);

	this.xhr
		.then(this.onDoneSubmitLogin.bind(this))
		.catch(this.onFailSubmitLogin.bind(this));
}

ModalAuthByEmail.prototype.onDoneSubmitLogin = function({ success, data: { redirectTo } }) {
	if (success) {
		if (redirectTo)
			setTimeout(() => location.replace(redirectTo), 1000);
		else
			setTimeout(() => location.reload(true), 1000);
	} else {
		this.onFailSubmitLogin(...arguments);
	}
}

ModalAuthByEmail.prototype.onFailSubmitLogin = function({ error }) {
	const $form = $(this.domElem)
		.find('.modal-auth-by-email__form_type_login');
	const fallback = error || $form.data('fallback');

	$form.trigger('_fail.form', fallback);
}

ModalAuthByEmail.prototype.onSubmitRestore = function({ currentTarget }) {
	const data = $(currentTarget).serialize();
	const url = currentTarget.dataset.api;
	const method = currentTarget.method;
	const options = { url, method, data };

	if (this.xhr)
		this.xhr.abort();

	this.xhr = $.ajax(options);

	this.xhr
		.then(this.onDoneSubmitRestore.bind(this))
		.catch(this.onDoneSubmitRestore.bind(this));
}

ModalAuthByEmail.prototype.onDoneSubmitRestore = function({ success, html }) {
	if (success) {
		$(this.domElem)
			.find('.modal-auth-by-email__form_type_login')
			.trigger('_success', html);

		this.toggleRestore();
	} else {
		this.onFailSubmitRestore(...arguments);
	}
}

ModalAuthByEmail.prototype.onFailSubmitRestore = function({ error }) {
	const $form = $(this.domElem)
		.find('.modal-auth-by-email__form_type_restore');
	const fallback = error || $form.data('fallback');

	$form.trigger('_fail.form', fallback);
}

$(() =>
	$('.modal-auth-by-email')
		.toArray()
		.forEach(initModalAuthByEmail)
);

export {
	ModalAuthByEmail,
	initModalAuthByEmail as default
};
